import { render, staticRenderFns } from "./TextAlignEdit.vue?vue&type=template&id=eb3ef7d6&scoped=true"
import script from "./TextAlignEdit.vue?vue&type=script&lang=js"
export * from "./TextAlignEdit.vue?vue&type=script&lang=js"
import style0 from "./TextAlignEdit.vue?vue&type=style&index=0&id=eb3ef7d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb3ef7d6",
  null
  
)

export default component.exports